const FactionModel = {};

FactionModel.ALLIANCE = {
  id: 1,
  title: 'Alliance',
};

FactionModel.HORDE = {
  id: 2,
  title: 'Horde',
};

FactionModel.ID_TO_DATA = {
  [FactionModel.ALLIANCE.id]: FactionModel.ALLIANCE,
  [FactionModel.HORDE.id]: FactionModel.HORDE,
};

FactionModel.LIST = [
  FactionModel.ALLIANCE,
  FactionModel.HORDE,
];

FactionModel.ID_TO_TITLE = {
  [FactionModel.ALLIANCE.id]: FactionModel.ALLIANCE.title,
  [FactionModel.HORDE.id]: FactionModel.HORDE.title,
};

export default FactionModel;
